import React from 'react';
import { motion } from 'framer-motion';

export default function Calendar() {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  // Dummy month grid (28 days for simpliticy in demo)
  const dates = Array.from({ length: 28 }, (_, i) => i + 1);
  
  const getDayStatus = (date) => {
    if (date === 12) return 'today';
    if ([3, 5, 8, 10, 15, 17].includes(date)) return 'completed';
    if ([14, 19, 22].includes(date)) return 'scheduled';
    return 'empty';
  };

  return (
    <div className="glass-panel p-6 h-full flex flex-col">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">SCHEDULE.MATRIX</h2>
          <p className="text-sm text-gray-400 font-mono">Current Cycle: Phase 3 / Week 2</p>
        </div>
        <div className="flex gap-4 text-xs font-mono">
          <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-lime-500"></span> Today</div>
          <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-carbon-600 border border-lime-500"></span> Scheduled</div>
          <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-white opacity-50"></span> Completed</div>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-4 mb-4">
        {days.map(day => (
          <div key={day} className="text-center text-xs font-mono text-gray-500 uppercase tracking-wider">{day}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-2 md:gap-4 flex-1">
        {dates.map((date, i) => {
          const status = getDayStatus(date);
          return (
            <motion.div 
              key={date}
              whileHover={{ scale: 1.05, zIndex: 10 }}
              className={`
                relative rounded-xl border flex flex-col items-center justify-center min-h-[80px] md:min-h-[100px] cursor-pointer transition-colors
                ${status === 'today' ? 'bg-lime-500/10 border-lime-500 glow-lime' : 
                  status === 'completed' ? 'bg-carbon-700/50 border-carbon-600 text-gray-400' : 
                  status === 'scheduled' ? 'bg-carbon-800 border-lime-500/30' : 
                  'bg-carbon-900/50 border-carbon-800/50 hover:border-carbon-600'}
              `}
            >
              <span className={`text-lg font-bold ${status === 'today' ? 'text-lime-500' : 'text-white'}`}>{date}</span>
              
              {status === 'today' && <span className="absolute bottom-2 text-[10px] font-mono text-lime-500 font-bold">HYPERTROPHY</span>}
              {status === 'scheduled' && <span className="absolute bottom-2 text-[10px] font-mono text-gray-400">STRENGTH</span>}
              {status === 'completed' && <span className="absolute bottom-2 text-[10px] font-mono text-gray-600">REST</span>}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}